// extracted by mini-css-extract-plugin
export var logoWrapper = "ht_Bz";